<template>
  <div class="node" v-if="isVisible">
    <div class="expando mini round icon button" @click="toggle">
      <i
        class="icon"
        :class="{
          'caret down': isExpanded && hasChildren,
          'caret right': !isExpanded && hasChildren,
          'mini circle': !hasChildren,
          disabled: !hasChildren
        }"
      />
    </div>
    <div class="row">
      <div class="content" @click.stop.prevent="select">
        <div class="name">
          <slot name="name"> {{ node.name }}</slot>
        </div>
        <div class="detail" v-if="node.detail">
          {{ node.detail }}
        </div>
      </div>
      <div class="ui mini icon buttons">
        <button
          v-for="a in actions"
          :key="a.name"
          class="ui button"
          :class="[a.color]"
          @click.stop.prevent="emitAction(a, node)"
          :title="a.text"
        >
          <i class="icon" :class="[a.icon]" />
        </button>
      </div>
    </div>
    <div class="children" v-if="isExpanded">
      <TreeView
        v-for="child in node.children"
        :filter="filter"
        :node="child"
        :key="child.id || child.name"
        :actions="actions"
        @select="emitSelect"
        @action="emitAction"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.node {
  margin-top: 10px;
}

.row {
  display: inline-block;
  .buttons {
    display: none;
  }

  &:hover {
    .buttons {
      display: inline-flex;
    }
  }
}

.content {
  padding-left: 8px;
  padding-right: 8px;
  margin-top: 1px;
  padding-top: 4px;
  padding-bottom: 5px;
  cursor: pointer;
  &:hover {
    background-color: #f0f0f0;
    border-radius: 5px;
  }
}

.name,
.expando,
.content,
.detail {
  display: inline-block;
}

.detail {
  color: #888;
}

.children {
  margin-left: 20px;
}
</style>

<script>
import _ from 'lodash'

export default {
  name: 'TreeView',
  props: {
    node: {
      type: Object,
      required: true
    },
    filter: {
      type: String,
      default: ''
    },
    actions: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    isExpanded() {
      return (this.node.children && this.node.expanded) || !_.isEmpty(this.filter)
    },
    hasChildren() {
      return this.node.children && this.node.children.length > 0
    },
    isVisible() {
      return this.matchesFilter(this.node, this.filter)
    }
  },
  methods: {
    matchesFilter(node, filter) {
      // return true if node match or any of its children match
      return (
        node.name.toLowerCase().indexOf(filter.toLowerCase()) > -1 ||
        !_.isEmpty(_.find(node.children, c => this.matchesFilter(c, filter)))
      )
    },
    toggle() {
      if (!this.hasChildren) return
      this.$set(this.node, 'expanded', !this.node.expanded)
    },
    emitSelect(n) {
      this.$emit('select', n)
    },
    emitAction(a, n) {
      this.$emit('action', a, n)
    },
    select() {
      this.$emit('select', this.node)
    }
  }
}
</script>
